
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton, AppSelect, AppFormRow } from '@/components';
import { usePromotionItemList } from '@/modules/promotion/item/model/list';
import { Options, FilterType } from '@/modules/promotion/item/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.ITEM.INDEX,
    components: { AppTable, AppButton, AppSelect, AppFormRow, AppCard },
    setup() {
        const { list, total, fetchList, actions, query, personaOptions } = usePromotionItemList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Id', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Used Prototype Id',
                    key: 'prototypeName',
                    to: row => row.prototypeLink
                },
                {
                    type: TableColumnType.Option,
                    label: 'Display Type',
                    key: 'displayType',
                    options: Options.DisplayType
                },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: Options.Status },
                { type: TableColumnType.DateTime, label: 'To Time', key: 'toTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PROMOTION.ITEM.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PROMOTION.ITEM.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_PROMOTION.ITEM.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_PROMOTION.ITEM.CLONE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return {
            table,
            list,
            total,
            query,
            fetchList,
            actions,
            personaOptions,
            Options,
            FilterType,
            ROUTE_NAME_PROMOTION
        };
    }
});
